import { cx } from "@suse-o11y/class-variance";
import React from "react";

import styles from "./_table.module.css";
import { TableCell } from "./cell";

export type TableHeadCellProps = React.ComponentPropsWithoutRef<typeof TableCell>;

export const TableHeadCell = React.forwardRef<React.ComponentRef<typeof TableCell>, TableHeadCellProps>(
	({ className, ...props }, ref) => (
		<TableCell {...props} className={cx(styles.headCell, className)} ref={ref} role="columnheader" />
	),
);
